<template>
    <section class="footer-logos">
        <div class="container">
            <div class="columns is-multiline">
                <div class="column" v-for="(item, index) in footerLogos" :key="index">
                    <a :href="item.url" target="_blank" class="footer-logos__item">
                         <Image :image="item.image" :width="100" :height="44"></Image>
                        <!-- <img :src="item.image.url" :alt="item.image.alt"> -->
                    </a>
                </div> 
             </div>
        </div>
    </section>
</template>

<script>
import Image from "../elements/Image.vue";

export default {
    name: "ModuleFooterLogos", 
    components: {
        Image,
    },
    computed: {
        footerLogos() {
            return this.$store.getters.getFooterLogos;
        }
    },
    methods: {
        getFooterLogos() {
            this.$store.dispatch("getFooterLogos");
        },
    },
    mounted() {
        this.getFooterLogos();
    }
};
</script>
